"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.CookieConsentDefaultProps = exports.CookieConsent = void 0;

var _cookieConsent = _interopRequireDefault(require("./components/cookie-consent"));

exports.CookieConsent = _cookieConsent["default"];

var _cookieConsent2 = _interopRequireDefault(require("./components/cookie-consent.props/cookie-consent.defaultProps"));

exports.CookieConsentDefaultProps = _cookieConsent2["default"];